import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ChatSvg from 'images/v5/icons/annotation.svg';
import CameraSvg from 'images/v5/icons/camera-01.svg';
import Button from 'layout/atoms/Button/Button';
import { openSidebar } from 'store/layoutSlice';
import styles from './Tools.module.scss';
function Tools({ url }) {
    const dispatch = useDispatch();
    const classes = classNames(styles.wrap);
    const location = useLocation();
    const chatUrl = url || location.pathname;
    return (React.createElement("div", { className: classes },
        React.createElement(Button, { size: "m", color: "primary", shape: "rounded", leftIcon: React.createElement(ChatSvg, null), onClick: () => dispatch(openSidebar({ name: 'chat', data: { id: chatUrl } })) }),
        React.createElement(Button, { size: "m", color: "primary", shape: "rounded", leftIcon: React.createElement(CameraSvg, null), onClick: () => dispatch(openSidebar({ name: 'screenshot' })) })));
}
export default Tools;
